/* Build the string for passengers input info */
function buildPassengersLabel(literals, { adults = 1, children = 0, babies = 0 }) {
    const adultText = adults > 1 ? `${adults} ${literals.adultsLabel}` : `${adults} ${literals.adultLabel}`;
    const childrenText = children > 1 ? `${children} ${literals.childrenLabel}` : `${children} ${literals.childLabel}`;
    const babyText = babies > 1 ? `${babies} ${literals.babiesLabel}` : `${babies} ${literals.babyLabel}`;

    /* Building text based on passengers quantity */
    /* Adult with children */
    if (children > 0 && babies === 0) return `${adultText}, ${childrenText}`;

    /* Adult with babies */
    if (children === 0 && babies > 0) return `${adultText}, ${babyText}`;

    /* Adult with children and babies */
    if (children > 0 && babies > 0) return `${adultText}, ${childrenText}, ${babyText}`;

    /* Only adults, we always have minimum adults */
    return adultText;
}

module.exports = {
    buildPassengersLabel
};
